// extracted by mini-css-extract-plugin
export default {"description":"Description_description__0bEPM","descriptionContainer":"Description_descriptionContainer__4g-C6","fade":"Description_fade__nCzsz","button":"Description_button__aKNiv"};